import { render, staticRenderFns } from "./NoticiaWorld.vue?vue&type=template&id=ea0ecc1c&scoped=true"
import script from "./NoticiaWorld.vue?vue&type=script&lang=js"
export * from "./NoticiaWorld.vue?vue&type=script&lang=js"
import style0 from "./NoticiaWorld.vue?vue&type=style&index=0&id=ea0ecc1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea0ecc1c",
  null
  
)

export default component.exports